import React, { useState } from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { ChevronLeft, ChevronRight, Star, Quote, ArrowRight } from 'lucide-react';
import { testimonials } from '../data/mock';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const goToTestimonial = (index) => {
    setCurrentIndex(index);
  };

  return (
    <section className="py-16 px-6" id="testimonials">
      <div className="max-w-4xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Client Love
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Don't just take my word for it. Here's what clients say about working together to achieve their brand goals.
          </p>
        </div>

        {/* Testimonial Carousel */}
        <div className="relative">
          <Card 
            className="border-0 shadow-2xl overflow-hidden"
            style={{
              background: `linear-gradient(135deg, #ffe6fe 0%, #fdecff 50%, #dee4d0 100%)`
            }}
          >
            <CardContent className="p-12 text-center relative">
              {/* Quote Icon */}
              <div className="flex justify-center mb-6">
                <div className="bg-white/20 backdrop-blur-sm p-4 rounded-full">
                  <Quote className="h-8 w-8 text-gray-700" />
                </div>
              </div>

              {/* Stars */}
              <div className="flex justify-center gap-1 mb-6">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-6 w-6 fill-yellow-400 text-yellow-400" />
                ))}
              </div>

              {/* Testimonial Text */}
              <blockquote className="text-xl md:text-2xl text-gray-800 font-medium leading-relaxed mb-8 min-h-[120px] flex items-center justify-center">
                "{testimonials[currentIndex].text}"
              </blockquote>

              {/* Client Info */}
              <div className="space-y-2">
                <div className="font-semibold text-gray-900 text-lg">
                  {testimonials[currentIndex].client}
                </div>
                <div className="text-gray-700">
                  {testimonials[currentIndex].company}
                </div>
              </div>

              {/* Navigation Buttons */}
              <div className="flex justify-center gap-4 mt-8">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={prevTestimonial}
                  className="bg-white/20 backdrop-blur-sm hover:bg-white/30 text-gray-700 p-3 rounded-full transition-all duration-200 hover:scale-110"
                >
                  <ChevronLeft className="h-5 w-5" />
                </Button>
                
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={nextTestimonial}
                  className="bg-white/20 backdrop-blur-sm hover:bg-white/30 text-gray-700 p-3 rounded-full transition-all duration-200 hover:scale-110"
                >
                  <ChevronRight className="h-5 w-5" />
                </Button>
              </div>
            </CardContent>
          </Card>

          {/* Dots Indicator */}
          <div className="flex justify-center mt-8 gap-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToTestimonial(index)}
                className={`w-3 h-3 rounded-full transition-all duration-200 ${
                  index === currentIndex 
                    ? 'bg-pink-400 scale-125' 
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;